import { TAGS } from "../constants";
import { CreateTitration, Titration } from "../types";
import { api } from "./api";

export const titrationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPatientTitrationForProduct: builder.query<
      Titration,
      { patient_id: number; slug: string }
    >({
      query: ({ slug, patient_id }) => ({
        url: `/api/patients/${patient_id}/products/${slug}/titration`,
        method: "GET",
      }),
      providesTags: (_returns, _error, args) => [
        {
          type: TAGS.PRODUCT_TITRATION,
          id: `${args.patient_id}-${args.slug}`,
        },
      ],
    }),
    getTitrations: builder.query<
      Titration[],
      {
        price_id?: number;
        product?: string;
        ascending?: boolean;
        duration?: number;
      }
    >({
      query: (filter) => ({
        url: `/api/titrations`,
        method: "GET",
        params: filter,
      }),
      providesTags: [TAGS.PRODUCT_TITRATION],
    }),
    createNewTitration: builder.mutation<Titration, CreateTitration>({
      query: (body) => ({
        method: "POST",
        url: `/api/titrations`,
        body,
      }),
      invalidatesTags: [TAGS.PRODUCT_TITRATION],
    }),
    getTitration: builder.query<Titration, number>({
      query: (id) => ({
        method: "GET",
        url: `/api/titrations/${id}`,
      }),
      providesTags: (_returns, _error, args) => [
        {
          type: TAGS.TITRATION,
          id: args,
        },
      ],
    }),
  }),
});

export const {
  useGetPatientTitrationForProductQuery,
  useGetTitrationsQuery,
  useCreateNewTitrationMutation,
  useGetTitrationQuery,
} = titrationApi;
